// src/pages/client/components/ProfileSection.tsx
import { useState } from 'react';
import ProfilePhotoUpload from './ProfilePhotoUpload';
import type { AuthUser } from '@/domains/auth/services/auth.service';

interface ProfileSectionProps {
    user: AuthUser;
}

export default function ProfileSection({ user }: ProfileSectionProps) {
    const [profile, setProfile] = useState({
        firstnames: user.firstnames,
        lastname: user.lastname,
        phone: user.phone,
        email: user.email || '',
    });

    return (
        <div className="max-w-2xl mx-auto bg-white rounded-3xl shadow p-8">
            <h2 className="text-2xl font-bold mb-8">Mon Profil</h2>

            <div className="flex flex-col items-center mb-8">
                <ProfilePhotoUpload
                    currentPhoto=""
                    onPhotoChange={(photo:any) => console.log('Photo updated:', photo)}
                />
            </div>

            <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Prénom(s)</label>
                        <input
                            type="text"
                            value={profile.firstnames}
                            onChange={(e) => setProfile({ ...profile, firstnames: e.target.value })}
                            className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-teal-500"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Nom</label>
                        <input
                            type="text"
                            value={profile.lastname}
                            onChange={(e) => setProfile({ ...profile, lastname: e.target.value })}
                            className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-teal-500"
                        />
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Téléphone</label>
                    <input type="tel" value={profile.phone} className="w-full px-4 py-3 border rounded-xl" />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                    <input type="email" value={profile.email} className="w-full px-4 py-3 border rounded-xl" />
                </div>

                <button className="w-full py-4 bg-teal-600 hover:bg-teal-700 text-white rounded-2xl font-medium mt-4 transition-colors">
                    Enregistrer les modifications
                </button>
            </div>
        </div>
    );
}